import Swiper, {Navigation} from "swiper";
import {MD_WIDTH, LG_WIDTH, XL_WIDTH} from "@main/helpers/const";

class GraduatesSlider {
    constructor(el) {
        this.el = el;
        this.next = document.querySelector(".js-graduates-next");
        this.prev = document.querySelector(".js-graduates-prev");
        const graduates = this.el.closest(".js-graduates");
        if (graduates) {
            this.next = graduates.querySelector(".js-graduates-next");
            this.prev = graduates.querySelector(".js-graduates-prev");
        }
        this.createGraduatesSlider();
    }

    createGraduatesSlider() {
        new Swiper(this.el, {
            modules: [Navigation],
            slidesPerView: "auto",
            watchSlidesProgress: true,
            spaceBetween: 8,
            breakpoints: {
                [MD_WIDTH]: {
                    slidesPerView: Number(this.el.dataset.mdSlidePerView) || "auto",
                    spaceBetween: 16
                },
                [LG_WIDTH]: {
                    slidesPerView: Number(this.el.dataset.lgSlidePerView) || "auto",
                    spaceBetween: 15
                },
                [XL_WIDTH]: {
                    slidesPerView: Number(this.el.dataset.lgSlidePerView) || "auto",
                    spaceBetween: 15
                }
            },
            navigation: {
                nextEl: this.next,
                prevEl: this.prev
            }
        });
    }
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-graduates-slider")
        .forEach(slider => new GraduatesSlider(slider));
});
